import { IStrapiRichText } from '@components/common/StrapiRichText/StrapiRichText.type';
import { formatRichText, jsonToObject } from '@functions/functions';
import { axiosClient } from '@services/axios';
import qs from 'qs';
import { IGetNewsResponse, IRawNews } from './news.type';

const getNews = async (lastConnectionDate?: string): Promise<IGetNewsResponse> => {
	const query = qs.stringify(
		{
			filters: {
				$and: [
					{
						releaseDate: {
							$lt: new Date().toISOString()
						}
					},
					{
						releaseDate: {
							$gt: lastConnectionDate
						}
					}
				]
			},
			sort: 'releaseDate:desc',
			populate: {
				image: {
					fields: ['url']
				}
			}
		},
		{
			encodeValuesOnly: true
		}
	);

	const {
		data: { data }
	} = await axiosClient.get(`modals?${query}`);

	return data.map(({ id, attributes }: IRawNews) => {
		const {
			image,
			content: contentString,
			buttonText: closeButtonLabel,
			url: onConfirmationUrl,
			...remainderAttributes
		} = attributes;
		const content: IStrapiRichText[] = formatRichText(jsonToObject(contentString).blocks || []);
		const imgUrl = image?.data?.attributes?.url;

		return {
			id,
			data: { ...remainderAttributes, content, imgUrl, closeButtonLabel, onConfirmationUrl }
		};
	});
};

export { getNews };
